import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Surveyer from "../pages/surveyer/addSurveyer";
import PropertyDescription from "../pages/propertyDescription/addPropertyDescription";
import AddMunicipality from "../pages/municipality/addMunicipality";
import ViewMunicipality from "../pages/municipality/viewMunicipality";
import ViewSurveyer from "../pages/surveyer/viewSurveyer";
import PropertyDescriptionList from "../pages/propertyDescription/propertyDescriptionList";
import PropertyType from "../pages/propertyType/propertyType";
import PropertyTypeDescriptionList from "../pages/propertyTypeDescription/propertyTypeDescriptionList";
import PurposeOfUseProperty from "../pages/purposeOfUseProperty/purposeOfUseProperty";
import UseOfProperty from "../pages/useOfProperty/useOfProperty";
import OccupancyType from "../pages/occupancyType/occupancyType";
import PropertyStructure from "../pages/propertyStructure/propertyStructure";
import AddPropertyTypeDescription from "../pages/propertyTypeDescription/addPropertyTypeDescription";
import AddPurposeOfProperty from "../pages/purposeOfUseProperty/addPurposeOfProperty";
import AddUseOfProperty from "../pages/useOfProperty/addUseOfProperty";
import AddOccupancyType from "../pages/occupancyType/addOccupancyType";
import AddPropertyStructure from "../pages/propertyStructure/addPropertyStructure";
import { EditMunicipality } from "../pages/municipality/editMunicipality";
import AddBorough from "../pages/municipality/borough/addBorough";
import BoroughList from "../pages/municipality/borough/boroughList";
import AddWard from "../pages/municipality/ward/addWard";
import WardList from "../pages/municipality/ward/wardList";
import AddStreet from "../pages/municipality/street/addStreet";
import StreetList from "../pages/municipality/street/streetList";
import AddHoldingNo from "../pages/municipality/holdingNo/addHoldingNo";
import HoldingNolist from "../pages/municipality/holdingNo/holdingNolist";
import { API_URLS } from "../apiUrl";
import SurveyorListInAdmin from "../pages/surveyer/surveyorListInAdmin";
import LocationList from "../pages/municipality/location/locationList";
import AddLocation from "../pages/municipality/location/addLocation";
import Reports from "../pages/reports/report";
import SurveyorReport from "../pages/surveyor-reports/surveyorReport";
import AdminScreen from "../pages/waterSupply/UserComponents/SuperAdmin/AdminScreen";
import CollectorList from "../pages/waterSupply/UserComponents/collector/CollectorList";
import AccountentList from "../pages/waterSupply/UserComponents/accountant/AccountentList";
import axiosInstance from "./axiosInstance";
import Collector from "../pages/waterSupply/UserComponents/collector/Collector";
import Accountant from "../pages/waterSupply/UserComponents/accountant/Accountant";
import CounterCollector from "../pages/waterSupply/UserComponents/CounterCollector/CounterCollector";
import AddCollector from "../pages/waterSupply/UserComponents/collector/AddCollector";
import Addcashier from "../pages/waterSupply/UserComponents/accountant/Addcashier";
import MenicipaltyAdmin from "../pages/waterSupply/UserComponents/municipaltyAdmin/MenicipaltyAdmin";
import Csvuploadstatus from "../pages/waterSupply/UserComponents/csvLogs/Csvuploadstatus";
import Csvfaildstatus from "../pages/waterSupply/UserComponents/csvLogs/Csvfaildstatus";
import AccountsReport from "../pages/waterSupply/UserComponents/accountant/AccountsReport";
import CustomerLegerd from "../pages/waterSupply/UserComponents/municipaltyAdmin/CustomerLegerd";
import CollectorReport from "../pages/waterSupply/UserComponents/collector/CollectorReport";
import Addmouza from "../pages/mouza/Addmouza";
import MouzaListing from "../pages/mouza/MouzaListing";
import CollectorDetails from "../pages/waterSupply/UserComponents/collector/CollectorDetails";
import DemandDraft from "../pages/waterSupply/UserComponents/demanDraft/DemandDraft";

interface DashboardProps {
  roleId: any;
  muniCipalityName: any;
  municipalityId: any;
  municipalityBanner: any;
  logo: any;
  isLogin: any;
}

const Dashboard: React.FC<DashboardProps> = ({
  roleId,
  muniCipalityName,
  municipalityId,
  logo,
  municipalityBanner,
}) => {
  const location = useLocation();
  const [selectedMenu, setSelectedMenu] = useState<string>("overview");
  const [selectedCollector, setSelectedCollector] = useState<any>(null);
  const [municipalityCount, setMunicipalityCount] = useState<any>("");
  const [surveyorCount, setSurveyorCount] = useState<any>("");

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    if (path) {
      setSelectedMenu(path);
      setSelectedCollector(null);
    }
  }, [location]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.post(`${API_URLS.MunicipalityCount}`, {
          role_id: 2,
        });
        setMunicipalityCount(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.post(`${API_URLS.SurveyorCount}`, {
          login_id: roleId === 2 ? municipalityId : 0,
        });
        setSurveyorCount(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [municipalityId, roleId]);

  localStorage.setItem("selectedMenu", location.pathname);
  const theRolename = localStorage.getItem("role_name");

  const handleViewCollectorDetails = (collector: any) => {
    setSelectedCollector(collector);       
    setSelectedMenu("collector-details"); 
  };

  const handleBackToCollectorList = () => {
    setSelectedCollector(null);
    setSelectedMenu("view-collector");
  };

  return (
    <>
      <div className="main-content flex bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white ml-64">
        <div className="flex-1 flex flex-col">
          <main className="p-6">
            {roleId === 1 ? null : (
              <>
                <div className="flex items-center gap-5">
                  <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
                    {muniCipalityName}
                  </h1>
                </div>
                {municipalityBanner === undefined ||
                municipalityBanner === null ||
                municipalityBanner === "null" ? (
                  <div className="mb-5 h-[200px] rounded-lg overflow-hidden bg-white [&_img]:w-full [&_img]:h-full [&_img]:object-cover">
                    <img src="/assets/dummy3.jpg" alt="" />
                  </div>
                ) : (
                  <div className="mb-5 h-[200px] rounded-lg overflow-hidden bg-white [&_img]:w-full [&_img]:h-full [&_img]:object-cover">
                    <img src="/assets/dummy3.jpg" alt="" />
                  </div>
                )}
              </>
            )}

            {selectedMenu === "overview" && (
              <div>
                <div>
                  {theRolename === "super admin" && <AdminScreen />}
                  {theRolename === "collector" && <Collector />}
                  {theRolename === "cashier" && <Accountant />}
                  {theRolename === "counter-collector" && <CounterCollector />}
                </div>
              </div>
            )}

            {selectedMenu === "add-municipality" && <AddMunicipality />}
            {selectedMenu === "view-municipality" && <ViewMunicipality />}
            {selectedMenu === "surveyor-list" && (
              <SurveyorListInAdmin/>
            )}
            {selectedMenu === "addpropertydescription" && <PropertyDescription />}
            {selectedMenu === "add-surveyer" && (
              <Surveyer
                muniCipalityName={muniCipalityName}
                municipalityId={municipalityId}
                roleId={roleId}
              />
            )}
            {selectedMenu === "view-surveyer" && (
              <ViewSurveyer municipalityId={municipalityId} roleId={roleId} />
            )}
            {selectedMenu === "propertydescriptionlist" && <PropertyDescriptionList />}
            {selectedMenu === "property-type" && <PropertyType />}
            {selectedMenu === "property-type-description" && <PropertyTypeDescriptionList />}
            {selectedMenu === "purpose-of-property" && <PurposeOfUseProperty />}
            {selectedMenu === "use-of-property" && <UseOfProperty />}
            {selectedMenu === "occupancy-type-list" && <OccupancyType />}
            {selectedMenu === "property-structure-list" && <PropertyStructure />}
            {selectedMenu === "add-property-type-description" && <AddPropertyTypeDescription />}
            {selectedMenu === "add-purpose-of-property" && <AddPurposeOfProperty />}
            {selectedMenu === "add-use-of-property" && <AddUseOfProperty />}
            {selectedMenu === "add-occupancy-type" && <AddOccupancyType />}
            {selectedMenu === "add-property-structure" && <AddPropertyStructure />}
            {selectedMenu === "edit-profile" && (
              <EditMunicipality
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
                roleId={roleId}
                municipalityBanner={municipalityBanner}
                logo={logo}
              />
            )}

            {selectedMenu === "admin-collector" && (
              <CollectorList onViewDetails={handleViewCollectorDetails} />
            )}
            {selectedMenu === "admin-accountant" && <AccountentList />}
            {selectedMenu === "add-collector" && <AddCollector />}

            {selectedMenu === "view-collector" && (
              <CollectorList onViewDetails={handleViewCollectorDetails} />
            )}

            {selectedMenu === "collector-details" && selectedCollector !== null && (
              <CollectorDetails
                data={selectedCollector}
                collectorId={selectedCollector.primary_id}
                onClose={handleBackToCollectorList}
              />
            )}

            {selectedMenu === "cashier-report" && <AccountsReport />}
            {selectedMenu === "add-cashier" && <Addcashier />}
            {selectedMenu === "view-cashier" && <AccountentList />}
            {selectedMenu === "admin-connections" && <MenicipaltyAdmin />}
            {selectedMenu === "csv-upload-status" && <Csvuploadstatus />}
            {selectedMenu === "csv-failed-status" && <Csvfaildstatus />}
            {selectedMenu === "customer-ledger" && <CustomerLegerd />}
            {selectedMenu === "collector-report" && <CollectorReport />}
            {selectedMenu === "demand-draft" && <DemandDraft />}

            {selectedMenu === "add-mouza" && (
              <Addmouza
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "mouza-list" && (
              <MouzaListing
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "add-borough" && (
              <AddBorough
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "borough-list" && (
              <BoroughList
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "add-ward" && (
              <AddWard
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "ward-list" && (
              <WardList
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "street-list" && (
              <StreetList
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "add-street" && (
              <AddStreet
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "add-holding" && (
              <AddHoldingNo
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "holding-list" && (
              <HoldingNolist
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "add-location" && (
              <AddLocation
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "location-list" && (
              <LocationList
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
            {selectedMenu === "reports" && <Reports />}
            {selectedMenu === "surveyor-reports" && (
              <SurveyorReport
                muniCipalityName={muniCipalityName}
                muniCipalityId={municipalityId}
              />
            )}
          </main>
        </div>
      </div>
    </>
  );
};

export default Dashboard;